import { previewActions } from "./types";

const addMenu = (previewData) => {
    return { type: previewActions.MENU_PREVIEW_ADD, 
            payload: { previewData } };
};

const clearMenu = () => {
    return { type: previewActions.MENU_PREVIEW_CLEAR };
};

const menuPreviewAction = {
    addMenu,
    clearMenu
}

export default menuPreviewAction;